import React, { useState, useEffect } from 'react';
import Logo from './Logo';
import Button from '../base/Button';
import './Navbar.css';

function Navbar() {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSignup = () => {
    const element = document.getElementById('signup');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`navbar ${hasScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-content">
        {/* Logo */}
        <a href="/" className="navbar-brand">
          <Logo variant="light" size="md" />
        </a>

        {/* CTA Button */}
        <Button 
          onClick={scrollToSignup}
          variant="primary"
          className="navbar-cta"
        >
          Start with us
        </Button>
      </div>
    </header>
  );
}

export default Navbar;






